// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { CopyFileFailedStatusDatagramBuf } from '../status/copy-file-failed-status-datagram-buf.js';
import { CopyFileProgressStatusDatagramBuf } from '../status/copy-file-progress-status-datagram-buf.js';
import { CopyFinishedStatusDatagramBuf } from '../status/copy-finished-status-datagram-buf.js';
import { CopyStartedStatusDatagramBuf } from '../status/copy-started-status-datagram-buf.js';
import { DidConnectAnonStatusDatagramBuf } from '../status/did-connect-anon-status-datagram-buf.js';
import { DidConnectAuthStatusDatagramBuf } from '../status/did-connect-auth-status-datagram-buf.js';
import { DidDisconnectAnonStatusDatagramBuf } from '../status/did-disconnect-anon-status-datagram-buf.js';
import { DidDisconnectAuthStatusDatagramBuf } from '../status/did-disconnect-auth-status-datagram-buf.js';
import { DownloadFileFailedStatusDatagramBuf } from '../status/download-file-failed-status-datagram-buf.js';
import { DownloadFileProgressStatusDatagramBuf } from '../status/download-file-progress-status-datagram-buf.js';
import { DownloadFinishedStatusDatagramBuf } from '../status/download-finished-status-datagram-buf.js';
import { DownloadProgressStatusDatagramBuf } from '../status/download-progress-status-datagram-buf.js';
import { DownloadStartedStatusDatagramBuf } from '../status/download-started-status-datagram-buf.js';
import { UploadFileFailedStatusDatagramBuf } from '../status/upload-file-failed-status-datagram-buf.js';
import { UploadFileProgressStatusDatagramBuf } from '../status/upload-file-progress-status-datagram-buf.js';
import { UploadFinishedStatusDatagramBuf } from '../status/upload-finished-status-datagram-buf.js';
import { UploadStartedStatusDatagramBuf } from '../status/upload-started-status-datagram-buf.js';
import { WentOfflineAnonStatusDatagramBuf } from '../status/went-offline-anon-status-datagram-buf.js';
import { WentOfflineAuthStatusDatagramBuf } from '../status/went-offline-auth-status-datagram-buf.js';
import { WentOnlineAnonStatusDatagramBuf } from '../status/went-online-anon-status-datagram-buf.js';
import { WentOnlineAuthStatusDatagramBuf } from '../status/went-online-auth-status-datagram-buf.js';


export class StatusDatagramBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StatusDatagramBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStatusDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:StatusDatagramBuf):StatusDatagramBuf {
  return (obj || new StatusDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStatusDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:StatusDatagramBuf):StatusDatagramBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StatusDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

didConnectAuthStatus(obj?:DidConnectAuthStatusDatagramBuf):DidConnectAuthStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new DidConnectAuthStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

didDisconnectAuthStatus(obj?:DidDisconnectAuthStatusDatagramBuf):DidDisconnectAuthStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new DidDisconnectAuthStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

didConnectAnonStatus(obj?:DidConnectAnonStatusDatagramBuf):DidConnectAnonStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new DidConnectAnonStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

didDisconnectAnonStatus(obj?:DidDisconnectAnonStatusDatagramBuf):DidDisconnectAnonStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new DidDisconnectAnonStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

wentOfflineAuthStatus(obj?:WentOfflineAuthStatusDatagramBuf):WentOfflineAuthStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new WentOfflineAuthStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

wentOfflineAnonStatus(obj?:WentOfflineAnonStatusDatagramBuf):WentOfflineAnonStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new WentOfflineAnonStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

wentOnlineAuthStatus(obj?:WentOnlineAuthStatusDatagramBuf):WentOnlineAuthStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new WentOnlineAuthStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

wentOnlineAnonStatus(obj?:WentOnlineAnonStatusDatagramBuf):WentOnlineAnonStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new WentOnlineAnonStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

uploadStartedStatus(obj?:UploadStartedStatusDatagramBuf):UploadStartedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new UploadStartedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

uploadFileProgressStatus(obj?:UploadFileProgressStatusDatagramBuf):UploadFileProgressStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new UploadFileProgressStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

uploadFileFailedStatus(obj?:UploadFileFailedStatusDatagramBuf):UploadFileFailedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new UploadFileFailedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

uploadFinishedStatus(obj?:UploadFinishedStatusDatagramBuf):UploadFinishedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new UploadFinishedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

downloadStartedStatus(obj?:DownloadStartedStatusDatagramBuf):DownloadStartedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? (obj || new DownloadStartedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

downloadProgressStatus(obj?:DownloadProgressStatusDatagramBuf):DownloadProgressStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? (obj || new DownloadProgressStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

downloadFileProgressStatus(obj?:DownloadFileProgressStatusDatagramBuf):DownloadFileProgressStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? (obj || new DownloadFileProgressStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

downloadFileFailedStatus(obj?:DownloadFileFailedStatusDatagramBuf):DownloadFileFailedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? (obj || new DownloadFileFailedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

downloadFinishedStatus(obj?:DownloadFinishedStatusDatagramBuf):DownloadFinishedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? (obj || new DownloadFinishedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

copyStartedStatus(obj?:CopyStartedStatusDatagramBuf):CopyStartedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? (obj || new CopyStartedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

copyFileProgressStatus(obj?:CopyFileProgressStatusDatagramBuf):CopyFileProgressStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? (obj || new CopyFileProgressStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

copyFileFailedStatus(obj?:CopyFileFailedStatusDatagramBuf):CopyFileFailedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? (obj || new CopyFileFailedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

copyFinishedStatus(obj?:CopyFinishedStatusDatagramBuf):CopyFinishedStatusDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? (obj || new CopyFinishedStatusDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startStatusDatagramBuf(builder:flatbuffers.Builder) {
  builder.startObject(21);
}

static addDidConnectAuthStatus(builder:flatbuffers.Builder, didConnectAuthStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, didConnectAuthStatusOffset, 0);
}

static addDidDisconnectAuthStatus(builder:flatbuffers.Builder, didDisconnectAuthStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, didDisconnectAuthStatusOffset, 0);
}

static addDidConnectAnonStatus(builder:flatbuffers.Builder, didConnectAnonStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, didConnectAnonStatusOffset, 0);
}

static addDidDisconnectAnonStatus(builder:flatbuffers.Builder, didDisconnectAnonStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, didDisconnectAnonStatusOffset, 0);
}

static addWentOfflineAuthStatus(builder:flatbuffers.Builder, wentOfflineAuthStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, wentOfflineAuthStatusOffset, 0);
}

static addWentOfflineAnonStatus(builder:flatbuffers.Builder, wentOfflineAnonStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, wentOfflineAnonStatusOffset, 0);
}

static addWentOnlineAuthStatus(builder:flatbuffers.Builder, wentOnlineAuthStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, wentOnlineAuthStatusOffset, 0);
}

static addWentOnlineAnonStatus(builder:flatbuffers.Builder, wentOnlineAnonStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, wentOnlineAnonStatusOffset, 0);
}

static addUploadStartedStatus(builder:flatbuffers.Builder, uploadStartedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, uploadStartedStatusOffset, 0);
}

static addUploadFileProgressStatus(builder:flatbuffers.Builder, uploadFileProgressStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, uploadFileProgressStatusOffset, 0);
}

static addUploadFileFailedStatus(builder:flatbuffers.Builder, uploadFileFailedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, uploadFileFailedStatusOffset, 0);
}

static addUploadFinishedStatus(builder:flatbuffers.Builder, uploadFinishedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, uploadFinishedStatusOffset, 0);
}

static addDownloadStartedStatus(builder:flatbuffers.Builder, downloadStartedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(12, downloadStartedStatusOffset, 0);
}

static addDownloadProgressStatus(builder:flatbuffers.Builder, downloadProgressStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(13, downloadProgressStatusOffset, 0);
}

static addDownloadFileProgressStatus(builder:flatbuffers.Builder, downloadFileProgressStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(14, downloadFileProgressStatusOffset, 0);
}

static addDownloadFileFailedStatus(builder:flatbuffers.Builder, downloadFileFailedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(15, downloadFileFailedStatusOffset, 0);
}

static addDownloadFinishedStatus(builder:flatbuffers.Builder, downloadFinishedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(16, downloadFinishedStatusOffset, 0);
}

static addCopyStartedStatus(builder:flatbuffers.Builder, copyStartedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(17, copyStartedStatusOffset, 0);
}

static addCopyFileProgressStatus(builder:flatbuffers.Builder, copyFileProgressStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(18, copyFileProgressStatusOffset, 0);
}

static addCopyFileFailedStatus(builder:flatbuffers.Builder, copyFileFailedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(19, copyFileFailedStatusOffset, 0);
}

static addCopyFinishedStatus(builder:flatbuffers.Builder, copyFinishedStatusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(20, copyFinishedStatusOffset, 0);
}

static endStatusDatagramBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
